import { useMemo, useState } from 'react';

import { Alert, Box, CircularProgress } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { PedidoCartProduct } from 'pages/compra/pedido/components';

interface PedidoCompraCartAsideProps {
    isFetching: boolean;
}

export function PedidoCompraCartAside({ isFetching }: PedidoCompraCartAsideProps) {
    const { produtoCartList, isEmptyCart } = usePedidoCompraContext();
    const [search, setSearch] = useState<string>('');

    const produtoCartListFiltered = useMemo(() => {
        const filteredList = produtoCartList.filter((produtoCart) => {
            const { dsProduto } = produtoCart.produto;
            const includeSearch = dsProduto.toLowerCase().includes(search.toLowerCase());
            return includeSearch;
        });

        return filteredList.map((produtoCart) => <PedidoCartProduct key={produtoCart.produto.idProduto} produtoCart={produtoCart} />);
    }, [produtoCartList, search]);

    return (
        <Block
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                gap: 2,
            }}
        >
            <SubTitle label="Detalhes do Pedido" sx={{ width: 'auto', mb: 0 }} />

            {isEmptyCart && !isFetching && <Alert severity="info">Sem produtos no pedido atual</Alert>}

            {isFetching && (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress size={20} />
                </Box>
            )}

            {!isEmptyCart && !isFetching && (
                <>
                    <Box sx={{ display: 'flex', flexShrink: 0 }}>
                        <CissTextField label="Pesquisar" placeholder="Nome do produto" onChange={(e) => setSearch(e.target.value)} size="small" />
                    </Box>

                    <Box
                        sx={{
                            '> hr:last-of-type': {
                                display: 'none',
                            },
                            'overflowY': 'auto',
                            'overflowX': 'hidden',
                            'flex': 1,
                        }}
                    >
                        {produtoCartListFiltered}

                        {!produtoCartListFiltered.length && <Alert severity="info">Sem produtos correspondentes</Alert>}
                    </Box>
                </>
            )}
        </Block>
    );
}
